export default __webpack_public_path__ + "static/media/Flexicap-Fund-Banner.e76de9ae.gif";